
import * as ipxRuntime$_9_45_45BHkRa86kZ_J_45ownBDoq5MJ_9E9Iibz_fg1hRLQZ0 from '/var/www/frontend/c-rent-client-vue/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "thumb": {
      "modifiers": {
        "format": "webp",
        "quality": 50
      },
      "placeholder": true
    }
  },
  "provider": "ipx",
  "domains": [
    "api.balibikesisland.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_9_45_45BHkRa86kZ_J_45ownBDoq5MJ_9E9Iibz_fg1hRLQZ0, defaults: {} }
}
        